import React from 'react'
import COLORS from '../../../styles/colors'

const defaultSize = {
  width: 24,
  height: 38,
}

const fridge = ({ style = {}, color = COLORS.brand.primary }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    style={{ ...defaultSize, ...style }}
    viewBox='0 0 24.063 38.5'
  >
    <g fill={color}>
      <path d='M21.055,0H3.008A3.011,3.011,0,0,0,0,3.008V32.484a3.011,3.011,0,0,0,3.008,3.008H3.76v.752A2.259,2.259,0,0,0,6.016,38.5h.752a1.505,1.505,0,0,0,1.5-1.5v-1.5h7.52V37a1.505,1.505,0,0,0,1.5,1.5h.752A2.259,2.259,0,0,0,20.3,36.244v-.752h.752a3.011,3.011,0,0,0,3.008-3.008V3.008A3.011,3.011,0,0,0,21.055,0ZM6.768,37H6.016a.753.753,0,0,1-.752-.752v-.752h1.5V37ZM18.8,36.244a.753.753,0,0,1-.752.752h-.752v-1.5h1.5Zm3.76-3.76a1.505,1.505,0,0,1-1.5,1.5H3.008a1.505,1.505,0,0,1-1.5-1.5V14.438H22.559Zm0-19.551H1.5V3.008a1.505,1.505,0,0,1,1.5-1.5H21.055a1.505,1.505,0,0,1,1.5,1.5Zm0,0' />
      <path
        d='M46.948,96.512H41.684a1.506,1.506,0,0,1-1.5-1.5v-.752A2.258,2.258,0,0,1,42.436,92H46.2a2.258,2.258,0,0,1,2.256,2.256v.752A1.506,1.506,0,0,1,46.948,96.512ZM42.436,93.5a.753.753,0,0,0-.752.752v.752h5.264v-.752A.753.753,0,0,0,46.2,93.5Zm0,0'
        transform='translate(-37.159 -85.082)'
      />
      <path
        d='M46.2,216.512h-3.76a2.258,2.258,0,0,1-2.256-2.256V213.5a1.506,1.506,0,0,1,1.5-1.5h5.264a1.506,1.506,0,0,1,1.5,1.5v.752A2.258,2.258,0,0,1,46.2,216.512ZM41.684,213.5v.752a.753.753,0,0,0,.752.752H46.2a.753.753,0,0,0,.752-.752V213.5Zm0,0'
        transform='translate(-37.159 -196.059)'
      />
      <path
        d='M260.752,339.52a.752.752,0,0,1-.752-.752v-6.016a.752.752,0,0,1,1.5,0v6.016A.752.752,0,0,1,260.752,339.52Zm0,0'
        transform='translate(-240.449 -307.035)'
      />
      <path
        d='M260.768,293.5a.752.752,0,1,1,0-1.5h0a.752.752,0,0,1,0,1.5Zm0,0'
        transform='translate(-240.464 -270.043)'
      />
    </g>
  </svg>
)

export default fridge
